export default "__VITE_ASSET__CTnijOsI__"